import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import clsx from 'clsx'
import EmbedVideoIframe from '../Utils/EmbedVideoIframe'
import placeholder from '../../../images/placeholder_acm.png'
import { useSelector } from 'react-redux'

const CarouselGallerySimple = ({
  items,
  zoom,
  special,
  onImageClick,
  onClose,
  spinCarUrl,
  color,
}) => {
  const toggleCheckGallery = useSelector(
    (state) => state.toggleGallery360.toggleCheckGallery
  )
  const [modalOpen, setModalOpen] = useState(false)

  if (spinCarUrl && toggleCheckGallery) {
    return (
      <>
        <div
          className={clsx(
            'iframe-wrapper',
            { open: modalOpen },
            { 'with-360': spinCarUrl }
          )}
        >
          <div
            className="iframe-wrapper__modal-toggler"
            onClick={() => setModalOpen(!modalOpen)}
          >
            <svg
              style={{ display: modalOpen ? 'none' : 'block' }}
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 14H2V10"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 13.9999L6.66667 9.33325"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 2H14V6"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.0002 2L9.3335 6.66667"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <svg
              style={{ display: modalOpen ? 'block' : 'none' }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className="iframe-wrapper__modal-overlay"
            onClick={() => setModalOpen(!modalOpen)}
          ></div>
          <iframe
            style={{ width: '100%', aspectRatio: '400/225' }}
            src={`${spinCarUrl}!disabledrawer!lang=pt-BR!stscolor=${color}`}
            frameBorder="0"
          ></iframe>
        </div>
      </>
    )
  } else {
    return (
      <>
        <div
          className={clsx(
            'carousel-gallery-simple',
            {
              'carousel-gallery-simple--zoom': zoom,
            },
            {
              'with-gallery': spinCarUrl,
            }
          )}
        >
          <div
            className={clsx('carousel-gallery-simple__cta', {
              'd-none': !zoom,
            })}
          >
            <a
              href="#"
              className="icon icon-times-solid carousel-gallery-simple__close"
              onClick={onClose}
            />
          </div>

          <Swiper
            className="swiper-container"
            loop={items.length > 10}
            modules={[Pagination]}
            pagination={{
              horizontalClass: 'carousel-gallery-simple__pagination',
              clickable: true,
            }}
            slidesPerView={1}
          >
            {items.length > 0 ? (
              items.map((item, index) => (
                <SwiperSlide
                  className={clsx('swiper-slide-container', {
                    'carousel-gallery-simple__slide--zoom': zoom,
                  })}
                  key={item.image.small_webp.url}
                >
                  {special && (
                    <div className="carousel-gallery-simple__label">
                      Oferta especial
                    </div>
                  )}

                  {item.url ? (
                    <EmbedVideoIframe url={item.url} />
                  ) : (
                    <img
                      className={clsx('carousel-gallery-simple__image', {
                        'carousel-gallery-simple__image--zoom': zoom,
                      })}
                      onClick={() => onImageClick(index)}
                      src={item.image.small_webp.url}
                    />
                  )}
                </SwiperSlide>
              ))
            ) : (
              <SwiperSlide className="swiper-slide-container">
                {special && (
                  <div className="carousel-gallery-simple__label">
                    Oferta especial
                  </div>
                )}

                {
                  <img
                    className={clsx('carousel-gallery-simple__image', {
                      'carousel-gallery-simple__image--zoom': zoom,
                    })}
                    src={placeholder}
                  />
                }
              </SwiperSlide>
            )}
          </Swiper>
        </div>
      </>
    )
  }
}

CarouselGallerySimple.defaultProps = {
  item: [],
  zoom: false,
  onImageClick() {},
  onClose() {},
}

CarouselGallerySimple.propTypes = {
  item: PropTypes.array,
  zoom: PropTypes.bool,
  onImageClick: PropTypes.func,
  onClose: PropTypes.func,
}

export default CarouselGallerySimple
